module.exports = __webpack_public_path__ + "static/media/footer-layout-1.d55f0998.svg";